const state = () => ({
  locations: [],
})

const actions = {
  setLocationsData({ commit }, locations) {
    if (!Array.isArray(locations)) {
      locations = []
    }

    locations.forEach(function (location) {
      location.selected = false
    })
    commit('LOAD_LOCATIONS_DATA', locations)
  },
  toggleLocationState({ commit }, locationId) {
    commit('TOGGLE_LOCATION_STATE', locationId)
  },
  clearSelected({ commit }) {
    commit('CLEAR_SELECTED_LOCATIONS')
  },
}

const mutations = {
  CLEAR_SELECTED_LOCATIONS(state) {
    state.locations.forEach(function (location) {
      location.selected = false
    })
  },
  LOAD_LOCATIONS_DATA(state, locations) {
    state.locations = []
    state.locations = locations
  },
  TOGGLE_LOCATION_STATE(state, locationId) {
    let objIndex = state.locations.findIndex((obj) => obj.id === locationId)
    state.locations[objIndex].selected = !state.locations[objIndex].selected
  },
}

const getters = {
  getLocations: (state) => {
    return state.locations
  },
  getLocationsBySearch: (state) => (search) => {
    let searchStr = search.trim().toLowerCase()
    if (searchStr === '') return state.locations
    return state.locations.filter(
      (location) => location.name.toLowerCase().indexOf(searchStr) > -1
    )
  },
  getSelectedLocations: (state) => {
    return state.locations.filter((location) => location.selected)
  },
  getSelectedLocationIds: (state) => {
    return state.locations
      .filter((location) => location.selected)
      .map((location) => {
        if (location.selected) return location.id
      })
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
